import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07f090ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cells" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "cell__sextant" }
const _hoisted_4 = { class: "cell__numbers" }
const _hoisted_5 = {
  key: 0,
  class: "cell__row"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "cell__disabled"
}


import IconTemplate from '@/apps/components/IconTemplate.vue'
import { ScreeningControllerInterface } from '@/pages/ScreeningPage/screeningController'
import { CellsIDS } from '@/pages/ScreeningPage/screeningModel'
import {
  ExaminationModel,
  ExaminationValueType,
} from '@/pages/ScreeningPage/examinationModel'

interface Props {
  screeningController: ScreeningControllerInterface
}


export default /*#__PURE__*/_defineComponent({
  props: {
    screeningController: null
  },
  setup(__props: any) {



function getStylesCell(id: CellsIDS, isActive: boolean) {
  const styles = {
    'cell_up-down': id > 2,
    cell_disabled: !isActive,
    'cell_left-top': id === 0,
    'cell_right-top': id === 2,
    'cell_left-bottom': id === 3,
    'cell_right-bottom': id === 5,
  }

  return styles
}

function getStylesCellValue(value: ExaminationValueType) {
  const styles = {
    cell__value_normal: [0, 1].includes(value),
    cell__value_warning: value === 2,
    cell__value_danger: value > 2,
  }

  return styles
}

function getStylesCellContent(cell: ExaminationModel) {
  const isUpDown = cell.id > 2
  let isWarning, isHealthy, isDanger

  if (cell.isActive) {
    isWarning = cell.value === 2 && cell.isActive
    isHealthy = [0, 1].includes(cell.value)
    isDanger = cell.value > 2 || cell.furcation
  }

  const styles = {
    'cell__content_up-down': isUpDown,
    cell__content_normal: isHealthy ?? false,
    cell__content_warning: isWarning ?? false,
    cell__content_danger: isDanger ?? false,
  }

  return styles
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.screeningController.examinationCells, (cell) => {
      return (_openBlock(), _createElementBlock("div", {
        key: cell.id,
        class: _normalizeClass([getStylesCell(cell.id, cell.isActive), "cell"])
      }, [
        _createElementVNode("div", {
          class: "cell__header",
          onClick: ($event: any) => (cell.switchStatusCell())
        }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(cell.sextant) + " секстант", 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(cell.numbers), 1)
        ], 8, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass([getStylesCellContent(cell), "cell__content"])
        }, [
          (cell.isActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass([getStylesCellValue(cell.value), "cell__value"]),
                  onClick: ($event: any) => (cell.changeExaminationValue())
                }, _toDisplayString(cell.value), 11, _hoisted_6),
                _createElementVNode("div", {
                  class: _normalizeClass([{ cell__furcation_active: cell.furcation }, "cell__furcation"]),
                  onClick: ($event: any) => (cell.switchStatusFurcation())
                }, " * ", 10, _hoisted_7)
              ]))
            : _createCommentVNode("", true),
          (!cell.isActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(IconTemplate, { name: "disabled" })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    }), 128))
  ]))
}
}

})